import React from "react";
import { useSelector } from "react-redux";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import UpdateIsNfp from "./UpdateIsNfp";

const ConnectedUpdateIsNfp = () => {
    const categories = useSelector(selectAllCategories);
    const updateIsNfpProps = {
        categories,
    };
    return <UpdateIsNfp {...updateIsNfpProps} />;
};

export default ConnectedUpdateIsNfp;
